export const and = (...predicates) => {
  return (traffic) => {
    return predicates.every((predicate) => {
      return predicate(traffic);
    });
  };
};
